import { environment } from './../environments/environment';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AbstractSecurityStorage, AuthModule, LogLevel } from 'angular-auth-oidc-client';
import { MatDialogModule } from '@angular/material/dialog';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ToastrModule } from 'ngx-toastr';
import { JoyrideModule } from 'ngx-joyride';

/*=============================================
=            Core           =
=============================================*/

import { PlayerModule } from './core/eagle-communication/player.module';
/*=====  End of Core ======*/

/*=============================================
=            Custom            =
=============================================*/

import { AppComponent } from './app.component';
// import { RoutingModule } from './routing/routing.module';
import { AppRoutingModule } from './app-routing.module';
import { BoundaryService } from './services/boundary.service';
import { LocalStorageService } from './services/local-storage.service';
import { MessageHandlerService } from './services/message-handler.service';
import { HttpService } from './services/http/http.service';
// import { HeaderModule } from './components/header/header.module';
// import { HoverChartModule } from './components/hover-chart/hover-chart.module';
import { DialogComponent } from './modules/auth/components/dialog/dialog.component';
// import { HomeComponent } from './modules/home/home.component';
/*=====  End of Custom  ======*/

/*=============================================
=            NGRX STATE            =
=============================================*/
import { metaReducers, reducers } from './reducers';
// import { HoverChartEffects } from './state/hover-chart.effect';
import { hoverDataFeature } from './state/hover-chart.reducer';
import { AuthInterceptor } from './interceptors/auth.interceptor';

/*=====  End of NGRX STATE  ======*/

//components
import { MicrostrategyCdnComponent } from './components/microstrategy-cdn/microstrategy-cdn.component';
import { historyDataFeature } from './state/history.reducer';
import { HistoryEffects } from './state/history.effect';
import { ErrorHandlerService } from './services/error-handler.service';

//DataDog Services
import { DatadogService } from './utils/datadog.service'; // Import the service

@NgModule({
	declarations: [AppComponent, DialogComponent, MicrostrategyCdnComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		MatIconModule,
		MatProgressSpinnerModule,
		MatMenuModule,
		MatToolbarModule,
		// NgxSliderModule,
		MatButtonModule,
		// HeaderModule,
		AuthModule.forRoot({
			config: {
				authority: environment.authorityUrl,
				authWellknownEndpointUrl: environment.authWellknownEndpointUrl,
				redirectUrl: window.location.origin + '/login/',
				clientId: environment.azureClientId,
				scope: 'Directory.Read.All email openid profile User.Read',
				responseType: 'code',
				silentRenew: false,
				maxIdTokenIatOffsetAllowedInSeconds: 600,
				issValidationOff: true,
				autoUserInfo: false,
				useRefreshToken: true,
				logLevel: LogLevel.Debug,
				postLogoutRedirectUri: window.location.origin + '/login/',
				customParamsAuthRequest: {
					prompt: 'login  ', // login, consent
				},
				historyCleanupOff: false,
			},
		}),
		PlayerModule,
		StoreModule.forRoot(reducers, {
			metaReducers,
		}),
		StoreModule.forFeature(hoverDataFeature),
		StoreModule.forFeature(historyDataFeature),
		// HoverChartModule,
		HttpClientModule,
		// EffectsModule.forRoot([HoverChartEffects, HistoryEffects]),
		AppRoutingModule,
		MatFormFieldModule,
		MatInputModule,
		ReactiveFormsModule,
		MatDialogModule,
		ToastrModule.forRoot({
			timeOut: 5000,
			positionClass: 'toast-center',
			preventDuplicates: true,
		}),
		JoyrideModule.forRoot(),
	],
	providers: [
		{ provide: AbstractSecurityStorage, useClass: LocalStorageService },
		MessageHandlerService,
		BoundaryService,
		MatSnackBar,
		HttpService,
		HttpClient,
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
		{ provide: ErrorHandler, useClass: ErrorHandlerService },
		DatadogService,
	],
	bootstrap: [AppComponent],
	exports: [],
})
export class AppModule {
	constructor(private datadogService: DatadogService) {
		this.datadogService.initializeDatadog(); // Initialize Datadog
	}
}
